import React from 'react';
import PdfPage from './PdfPage';

function PdfLand({ data, officeName, dateLabel }) {
  return (
    <PdfPage officeName={officeName} pageLabel="Land Information" dateLabel={dateLabel} className="p06">
      <div className="p06__chapter">
        <span className="eyebrow">Land</span>
        <h2 className="title">토지 정보</h2>
      </div>
      <div className="p06__body">
        <section>
          <h3 className="p06__sec-h">토지 정보 <span className="en">Land Profile</span></h3>
          <dl className="p06__profile">
            {data.rows.map((row, i) => (
              <div className="p06__row" key={i}>
                <dt>{row.label}</dt>
                <dd>
                  {row.value}
                  {row.unit && <span className="unit">{row.unit}</span>}
                  {row.sub && <span className="sub">{row.sub}</span>}
                </dd>
              </div>
            ))}
          </dl>
        </section>
      </div>
    </PdfPage>
  );
}

export default PdfLand;
